import { InteriorNPC } from "GameObjects/GameInterior/InteriorNPC";

import type { ILevelState } from "Interfaces/ILevelState";

export class InteriorNPCGiveQuest extends InteriorNPC {

    protected right: number = 100; // eyeballed
    protected bottom: number = 0;

    public init(pSize: PIXI.Point, pData: ILevelState) {
        return super.init(pSize, pData);
    }

    public animateIn() {
        super.animateIn();
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        super.destroy(pOptions);
    }
}
